import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProductManagersDashboard from './containers/ProductManagersDashboard';
import ProductManager from './containers/ProductManager';

export default function ProductManagersRoutes() {
  return (
    <Switch>
      <Route
        path="/w/:workspaceId/pm/product-managers/:productManagerId"
        component={ProductManager}
      />
      {/*
      <Route
      exact
      path="/w/:workspaceId/pm/capability-sets"
      component={CapabilitySetsDashboard}
      /> */}
      <Route
        path="/w/:workspaceId/pm/product-managers"
        component={ProductManagersDashboard}
      />
    </Switch>
  );
}
